import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { galleriesStore } from "../../../stores/galleries/galleriesStore";
import { WwwGalleryTabIcon } from "../../entities/galleries/gallery/WwwGalleryCard";
import { PhotoGalleryCategories } from "../../entities/posts/Photos/PhotoGallery";
import { useWidth } from "common-frontend-components";
import { styled } from '@mui/material/styles';
import { textColor } from "../../../assets/styles/colors";
import { UseLoaders } from "../../loaders/Loader";
import { galleryPhotosStore } from "../../../stores/galleries/galleryPhotosStore";
import { categoriesStore } from "../../../stores/useCategoriesStore";
import { postsStore } from "../../../stores/posts/postsStore";
import { photosStore } from "../../../stores/posts/usePhotosStore";
import { postCategoryAssociationsStore } from "../../../stores/posts/usePostCategoryAssociationsStore";
import { galleryCategoryAssociationsStore } from "../../../stores/galleries/galleryCategoryAssociationsStore";
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (_jsx("div", { role: "tabpanel", hidden: value !== index, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}`, ...other, children: value === index && (_jsx(Box, { sx: { p: 3 }, children: _jsx(Typography, { children: children }, void 0) }, void 0)) }, void 0));
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
export const GalleryTabPanels = () => {
    const galleries = galleriesStore.useGalleries();
    const value = galleriesStore.useTabPanelsDelayedValue();
    return (_jsx(UseLoaders, { useLoads: [
            categoriesStore.useLoad,
            postsStore.useLoad,
            photosStore.useLoad,
            postCategoryAssociationsStore.useLoad,
            galleryCategoryAssociationsStore.useLoad,
        ], onLoaded: () => _jsx(_Fragment, { children: galleries.map((i, index) => _jsx(TabPanel, { value: value, index: index, children: _jsx(PhotoGalleryCategories, { gallery: i }, void 0) }, i.id)) }, void 0) }, void 0));
};
const StyledTabs = styled((props) => (_jsx(Tabs, { ...props, TabIndicatorProps: { children: _jsx("span", { className: "MuiTabs-indicatorSpan" }, void 0) } }, void 0)))({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        maxWidth: 200,
        width: '100%',
        backgroundColor: textColor,
    },
});
export const GalleryTabs = () => {
    const galleries = galleriesStore.useGalleries();
    const value = galleriesStore.useTab();
    const width = useWidth();
    let tabWidth = galleries.length > 0 ? (width / galleries.length - 40) : 200;
    tabWidth = tabWidth < 1 ? 1 : tabWidth > 200 ? 200 : tabWidth;
    return (_jsx(UseLoaders, { useLoads: [galleriesStore.useLoad, galleryPhotosStore.useLoad], onLoaded: () => _jsxs(Box, { sx: { width: '100%' }, children: [_jsx(Box, { sx: { borderBottom: 1, borderColor: 'divider' }, children: _jsx(StyledTabs
                    // centered
                    , { 
                        // centered
                        value: value, onChange: galleriesStore.handleTabChange, 
                        // variant="scrollable"
                        // scrollButtons="auto"
                        variant: "fullWidth", "aria-label": "gallery-tabs", sx: {
                            '& .MuiTabs-indicatorSpan': {
                                maxWidth: 100,
                            }
                        }, children: galleries.map((i, index) => _createElement(Tab, { label: _jsx(WwwGalleryTabIcon, { gallery: i, width: tabWidth }, void 0), ...a11yProps(index), key: i.id })) }, void 0) }, void 0), _jsx(GalleryTabPanels, {}, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=GalleryTabs.js.map